import { MaestroVerde } from "./types";

export const state: MaestroVerde={
    espesor: [],
    largo:[],
    tipoMadera:[],
    defecto:[]
}